export class CityModalController {
  constructor(controller) {
    this.controller = controller;
  }

  openCityModal(event) {
    event.preventDefault();
    if (this.controller.hasCityModalTarget) {
      this.controller.cityModalTarget.classList.add('is-active');
      this.loadCitiesForPrefecture();
    }
  }

  // 市区町村リストを取得
  async fetchCities(prefectureName) {
    if (prefectureName === '都道府県を選択') return [];

    try {
      const response = await fetch(`/api/prefecture/${prefectureName}/cities`);
      if (!response.ok) return [];
      return await response.json();
    } catch {
      return [];
    }
  }

  // 政令指定都市リストを取得（is_major_cityフラグで抽出）
  async fetchMajorCities(prefectureName) {
    if (prefectureName === '都道府県を選択') return [];

    try {
      const response = await fetch(`/api/prefecture/${prefectureName}/cities_with_major`);
      if (!response.ok) return [];
      const cities = await response.json();
      return cities.filter(city => city.is_major_city);
    } catch {
      return [];
    }
  }

  async loadCitiesForPrefecture() {
    if (!this.controller.formValue.prefecture_name) {
      return;
    }

    if (this.controller.hasPrefectureNameTarget) {
      this.controller.prefectureNameTarget.textContent = this.controller.formValue.prefecture_name;
    }

    if (this.controller.hasCityButtonsContainerTarget) {
      const container = this.controller.cityButtonsContainerTarget;

      // 市区町村と政令指定都市を並行で取得
      const [cities, majorCities] = await Promise.all([
        this.fetchCities(this.controller.formValue.prefecture_name),
        this.fetchMajorCities(this.controller.formValue.prefecture_name)
      ]);

      // 政令指定都市と市区町村をマージ
      const allCities = [...majorCities, ...cities];

      container.innerHTML = '';

      const kanaGroups = [
        { group: 'あ', kanas: ['ア', 'イ', 'ウ', 'エ', 'オ'] },
        { group: 'か', kanas: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'] },
        { group: 'さ', kanas: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'] },
        { group: 'た', kanas: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'] },
        { group: 'な', kanas: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'] },
        { group: 'は', kanas: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'] },
        { group: 'ま', kanas: ['マ', 'ミ', 'ム', 'メ', 'モ'] },
        { group: 'や', kanas: ['ヤ', 'ユ', 'ヨ'] },
        { group: 'ら', kanas: ['ラ', 'リ', 'ル', 'レ', 'ロ'] },
        { group: 'わ', kanas: ['ワ', 'ヲ', 'ン'] }
      ];

      const kanaGroupData = [];

      kanaGroups.forEach(({ group, kanas }) => {
        const groupCities = allCities.filter(city => {
          if (!city.yomi) return false;
          const firstChar = city.yomi.slice(0, 1);
          return kanas.includes(firstChar);
        });

        if (groupCities.length > 0) {
          kanaGroupData.push({ kana: group, cities: groupCities });
        }
      });

      kanaGroupData.forEach((group) => {
        if (group.cities.length > 0) {
          const groupTitle = document.createElement('div');
          groupTitle.className = 'subsidies-search-panel__modal-city-group-title';
          groupTitle.textContent = `${group.kana}行`;
          container.appendChild(groupTitle);

          group.cities.forEach(city => {
            const button = document.createElement('button');
            button.className = 'subsidies-search-panel__modal-city-button';
            button.type = 'button';
            button.textContent = city.name;
            button.dataset.cityId = city.id;
            button.dataset.cityName = city.name;
            button.dataset.action = 'click->refosumu-subsidies-search-panel#selectCity';

            if (this.controller.formValue.city_name && this.controller.formValue.city_name === city.name) {
              button.classList.add('is-selected');
              if (!this.controller.formValue.city_id) {
                this.controller.formValue.city_id = city.id;
              }
            }

            container.appendChild(button);
          });
        }
      });
    }
  }

  async selectCity(event) {
    const button = event.currentTarget;

    this.controller.cityButtonsContainerTarget.querySelectorAll('.subsidies-search-panel__modal-city-button').forEach(btn => {
      btn.classList.remove('is-selected');
    });

    button.classList.add('is-selected');

    this.controller.formValue = {
      ...this.controller.formValue,
      city_id: button.dataset.cityId || null,
      city_name: button.dataset.cityName || null
    };

    if (this.controller.hasCityConfirmTarget) {
      const confirmButton = this.controller.cityConfirmTarget;
      const messageTarget = this.controller.hasCityNoResultsMessageTarget ? this.controller.cityNoResultsMessageTarget : null;
      await this.controller.updateModalButtonState(confirmButton, messageTarget, '決定する');
    }
  }

  confirmCitySelection(event) {
    event.preventDefault();
    if (this.controller.formValue.city_id) {
      if (this.controller.cityInputTextTarget) {
        this.controller.cityInputTextTarget.textContent = this.controller.formValue.city_name;
      }

      const cityInput = this.controller.element.querySelector('input[name="city_id"]');

      if (cityInput) {
        cityInput.value = this.controller.formValue.city_id || '';
      }
    }

    this.updateCityDisplay();
    this.controller.closeAllModals();
  }

  updateCityDisplay() {
    if (this.controller.hasCityInputTextTarget) {
      if (this.controller.formValue.city_name) {
        // 市区町村選択時: ピル型ボタンを表示
        const clearIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L10 8.93934L11.4697 7.46967C11.7626 7.17678 12.2374 7.17678 12.5303 7.46967C12.8232 7.76256 12.8232 8.23744 12.5303 8.53033L11.0607 10L12.5303 11.4697C12.8232 11.7626 12.8232 12.2374 12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303L10 11.0607L8.53033 12.5303C8.23744 12.8232 7.76256 12.8232 7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L8.93934 10L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z" fill="#FF8032"/></svg>';
        this.controller.cityInputTextTarget.innerHTML = `
          <button class="subsidies-search-panel__city-selected-button" type="button" data-refosumu-subsidies-search-panel-target="citySelectedButton">
            <span class="subsidies-search-panel__city-text">${this.controller.formValue.city_name}</span>
            <span class="subsidies-search-panel__city-clear-icon" data-action="click->refosumu-subsidies-search-panel#clearCity">${clearIconSvg}</span>
          </button>
        `;
      } else {
        // 未選択時: placeholderを表示
        this.controller.cityInputTextTarget.innerHTML = '<span class="subsidies-search-panel__city-placeholder">指定なし</span>';
      }
    }

    if (this.controller.hasCityInputBoxTarget) {
      if (this.controller.formValue.city_name) {
        this.controller.cityInputBoxTarget.classList.add('subsidies-search-panel__input-box--active');
      } else {
        this.controller.cityInputBoxTarget.classList.remove('subsidies-search-panel__input-box--active');
      }
    }

    // 変更ボタンと矢印アイコンの表示/非表示を切り替え
    if (this.controller.hasCityChangeButtonTarget) {
      this.controller.cityChangeButtonTarget.style.display = this.controller.formValue.city_name ? 'none' : '';
    }
    if (this.controller.hasCityArrowIconTarget) {
      this.controller.cityArrowIconTarget.style.display = this.controller.formValue.city_name ? 'none' : '';
    }
  }
}
